module.exports = __webpack_public_path__ + "static/media/promo_help_pic_freelancer@3x.39d1aa28875b52b83cde45ce6fad864c.png";